import Image from 'next/image'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'

import type { FC, HTMLProps } from 'react'

type CardPanduanProps = Exclude<HTMLProps<HTMLDivElement>, 'children'>

const CardPanduan: FC<CardPanduanProps> = ({ className }) => {
  return (
    <SimpleCard className={clsx('h-fit p-5 select-none', className)}>
      <div className="flex gap-4 items-center mb-6">
        <Image
          src="/illustrations/img-document-penci-fill.png"
          width={48}
          height={48}
          alt=""
        />

        <Text variant="heading-lg">Panduan</Text>
      </div>

      <ul className="list-disc list-outside px-5">
        <Text as="li">
          Diskusikan hasil pendampingan bersama Tim Kinerja. Sehingga Tim
          Kinerja memiliki pemahaman yang cukup untuk menilai.
        </Text>
        <Text as="li">
          Proses diskusi akan dinilai dengan mempertimbangkan isi catatan
          pendampingan dan survei Kepala Sekolah.
        </Text>
      </ul>
    </SimpleCard>
  )
}

export default CardPanduan
